import type { ReactElement } from 'react';
import { Box, Text, IconLocation, Stack, Inline } from 'braid-design-system';
import { observer } from 'mobx-react';
import { ContactLinks } from '../ContactLinks';
import { StarRatingInput } from '../../common/StarRatingInput';
import { BillableBadge } from 'src/components/common/BillableBadge';
import AppliedDate from 'src/components/list/JobApplicationCard/AppliedDate';
import type { Locale } from '@seek/melways-sites';
interface Props {
  candidateId: string;
  jobApplicationId: string;
  fullName: string;
  email: string;
  phone: string;
  rating: number;
  children: ReactElement;
  isMobile: boolean;
  onClickRating: (index: number) => number;
  locale: Locale;
  homeLocation?: string;
  billableStatus?: string;
  appliedDate: string;
  source: number;
}

const HeaderSection = ({
  candidateId,
  jobApplicationId,
  fullName,
  email,
  phone,
  rating,
  children,
  isMobile,
  onClickRating,
  homeLocation,
  billableStatus,
  locale,
  appliedDate,
  source,
}: Props) => {
  const shouldShowHomeLocation = homeLocation !== '';
  const shouldShowBillableBadge = billableStatus === 'BILLABLE';

  return (
    <Box paddingBottom="medium">
      <Stack space="medium">
        <Inline space="small" alignY="center">
          {shouldShowBillableBadge && <BillableBadge />}
          <AppliedDate
            appliedDate={appliedDate}
            isLoading={false}
            source={source}
            locale={locale}
          />
        </Inline>

        {shouldShowHomeLocation && (
          <Box
            paddingTop={{
              desktop: 'xsmall',
              tablet: 'xsmall',
            }}
          >
            <Text size="standard" icon={<IconLocation />}>
              {homeLocation}
            </Text>
          </Box>
        )}

        <ContactLinks email={email} phone={phone} candidateId={candidateId} />

        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          paddingTop={{
            mobile: 'xsmall',
            tablet: 'small',
            desktop: 'xsmall',
          }}
        >
          <Box flexGrow={1} marginLeft="none" paddingLeft="none">
            <StarRatingInput
              rating={rating}
              idPrefix={jobApplicationId}
              fullName={fullName}
              onClick={onClickRating}
            />
          </Box>
          {!isMobile && children}
        </Box>
      </Stack>
    </Box>
  );
};

export default observer(HeaderSection);
